<template>
	<ion-fab v-show="isScrollable === true && hasReachedBottom === true" slot="fixed" vertical="bottom" horizontal="end">
		<ion-fab-button @click="$emit('scroll-top')" class="scroll">
			<ion-icon :icon="icons.arrowUp"></ion-icon>
		</ion-fab-button>
	</ion-fab>

	<ion-fab v-show="isScrollable === true && hasReachedBottom === false" slot="fixed" vertical="bottom" horizontal="end">
		<ion-fab-button @click="$emit('scroll-bottom')" class="scroll">
			<ion-icon :icon="icons.arrowDown"></ion-icon>
		</ion-fab-button>
	</ion-fab>
</template>

<script>
import { arrowUp, arrowDown } from 'ionicons/icons'

export default {
	emits: ['scroll-top', 'scroll-bottom'],

	props: {
		isScrollable: {
			type: [Boolean, null],
			default: null
		},

		hasReachedBottom: {
			type: [Boolean, null],
			default: null
		}
	},

	data() {
		return {
			icons: {
				arrowUp,
				arrowDown
			}
		}
	},
}

</script>